import Vue from 'vue'
import VueRouter from 'vue-router'
import {getValidUser} from "@/utils/auth";
// import store from "@/store";

Vue.use(VueRouter)

const routes = [
    {
        path:'/',
        redirect:'/login',
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import('../views/Login')
    },
    {
        path: '/home',
        name: 'Home',
        component: () => import('../views/Home'),
        meta: {
            requireAuth: true,
            info:'首页'
        },
        children:[
            {
                path:'/manager',
                meta:{
                    info:'管理员管理'
                },
                component: () => import('../views/Manager')
            },
            {
                path:'/train',
                meta:{
                    info:'培训管理'
                },
                component: () => import('../views/Train')
            },
            {
                path:'/traintype',
                meta:{
                    info:'培训类型管理'
                },
                component: () => import('../views/TrainType')
            },
            {
                path:'/user',
                meta:{
                    info:'学员管理'
                },
                component: () => import('../views/User')
            },
            {
                path:'/receipt',
                meta:{
                    info:'订单管理'
                },
                component: () => import('../views/Receipt')
            },
            {
                path:'/list',
                meta:{
                    info:'学员管理'
                },
                component: () => import('../views/List')
            },
            {
                path:'/role',
                meta:{
                    info:'角色权限管理'
                },
                component: () => import('../views/Role')
            },
            {
                path:'/index',
                component: () => import('../views/Index')
            },
            {
                path:'/certificate',
                meta:{
                    info:'证书信息'
                },
                component: () => import('../views/Certificate')
            },
            {
                path:'/log',
                meta:{
                    info:'日志记录'
                },
                component: () => import('../views/Log')
            },
            {
                path:'/materials',
                meta:{
                    info:'素材管理'
                },
                component: () => import('../views/Materials')
            },
            {
                path:'/lesson',
                meta:{
                    info:'课程管理'
                },
                component: () => import('../views/Lesson')
            },
            {
                path:'/question',
                meta:{
                    info:'题库管理'
                },
                component: () => import('../views/Question')
            },
            {
                path:'/paper',
                meta:{
                    info:'试卷管理'
                },
                component: () => import('../views/Paper')
            },
            {
                path:'/class',
                meta:{
                    info:'班级管理'
                },
                component: () => import('../views/Class')
            },
            {
                path:'/class-study-detail',
                meta:{
                    info:'学员学习情况'
                },
                component: () => import('../views/ClassStudyDetail')
            },
        ]
    }
]

const router = new VueRouter({
    // mode: 'history',
    // base: process.env.BASE_URL,
    base:'/dist',
    routes
})

//提供一个重置路由的方法
export const resetRouter = () => {
    router.matcher = new VueRouter({
        // mode: 'history',
        // base: process.env.BASE_URL,
        base:'/dist',
        routes
    })
}

router.beforeEach((to, from, next) => {
    if (to.path === '/login') {
        return next()
    }
    if (to.matched.some(record => record.meta.requireAuth) && !isUserLoggedIn()) {
        // 如果用户未登录，则重定向到登录页面
        next('/login')
    } else {
        // 如果用户已登录，或者不需要认证，则正常导航
        next()
    }
})

function isUserLoggedIn() {
    return !!getValidUser()
}

export default router
